import React from 'react';
import { Link } from '@reach/router';
import { CenteredContainer } from '../../Components/CenteredContainer';
import { StaggeredAnimation } from '../../Components/StaggeredAnimation';
import { NavBar } from '../../Components/NavBar';
import { LazyP5Sketch } from '../../Backgrounds/LazyP5Sketch';
import { noiseWaveSketch } from './../../Backgrounds/noiseWaveSketch';
import pages from '../../Services/pages';
import './Styles/About.css';

export class About extends React.Component {
  constructor(props) {
    super(props);
    this.parts = [
      'a Software Engineer, in a constant pursuit of finding more elegant and efficient ways of solving problems.',
      "So far, d17e has been the densest representation of my full name, David Vandenbogaerde, that I've been able to come up with. Not a lossless solution, I agree, but a heck of a lot easier to type into an address bar, right?",
      'Anyways, welcome and thanks for dropping by :)',
      {
        render: () => (
          <div className="Subtext">
            Feel free to have a look around. You can find{' '}
            <Link to="/work">my CV</Link> on here,{' '}
            <Link to="/play">some projects</Link> I've been working on along the
            years, or just <Link to="/contact">get in touch</Link>.
          </div>
        )
      },
      {
        render: () => (
          <div className="Subtext">
            You can also play that <Link to="/landing">silly game</Link> again,
            if you're so inclined.
          </div>
        )
      }
    ];
    this.BG = LazyP5Sketch(noiseWaveSketch);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="Home">
        {this.BG}
        <NavBar pages={pages} active="about" width="100%" />
        <CenteredContainer ratio="90%" maxWidth="30em">
          <div className="Welcome">
            <h1>
              Hi!
              <br />
              I'm <span>David</span>,
            </h1>
          </div>
          <StaggeredAnimation
            items={this.parts}
            renderItem={this.renderPart}
            animation="fadeInDown"
            startHidden={true}
            duration={0.3}
            initialDelay={0.1}
            incrementalDelay={0.07}
          />
        </CenteredContainer>
      </div>
    );
  }

  renderPart = part => {
    if (part.render) {
      return part.render();
    }
    return <div className="Subtext">{part}</div>;
  };
}
